var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.68127 8.71881C5.85752 8.89506 6.14252 8.89506 6.3169 8.71881L9.91877 5.11881C10.095 4.94256 10.095 4.65756 9.91877 4.48318C9.74252 4.30881 9.45752 4.30693 9.28315 4.48318L6.0019 7.76443L2.71877 4.48131C2.54252 4.30506 2.25752 4.30506 2.08315 4.48131C1.90877 4.65756 1.9069 4.94256 2.08315 5.11693L5.68127 8.71881Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "341732316c7b161b69d38c653188c28b.svg";